import { AdvancedFilter, FilterMethod } from 'utils/gloo-types';
import { SelectOption } from './frontendTypes';

export const getTagColorFromStatus = (status) => {
  switch (status) {
    case 'Published':
      return 'darkNavy';
    case 'Unpublished':
      return 'lightNavy';
    case 'Draft':
      return 'white';
    case 'Archived':
      return 'inactive';
  }
};

interface getUpdatedConvoPromptsFiltersParams {
  filters: AdvancedFilter[];
  option: SelectOption;
  field: string;
}

const allUnarchivedStatuses = (existingFilter) =>
  ['Published', 'Unpublished', 'Draft'].every((status) => existingFilter?.compareValue1?.includes(status));

const createUpdatedFilter = (field, option, existingFilter) => {
  const compareValue1ToChange = option.value;
  const filterBehavior = existingFilter?.compareValue1.includes(compareValue1ToChange) ? 'remove' : 'add';

  const updatedFilter: AdvancedFilter = {
    field,
    method: field === 'topics' ? FilterMethod.oneOfArray : FilterMethod.oneOf,
    compareValue1: [compareValue1ToChange],
  };

  return { filterBehavior, updatedFilter, compareValue1ToChange };
};

export const getUpdatedConvoPromptsFilters = ({
  filters,
  option,
  field,
}: getUpdatedConvoPromptsFiltersParams): AdvancedFilter[] => {
  const existingFilter = filters?.find((f) => f.field === field);
  const removeExistingFilter = () => filters.filter((f) => f !== existingFilter);
  const setStatusFilterToAll = existingFilter
    ? allUnarchivedStatuses({ ...existingFilter, compareValue1: [...existingFilter.compareValue1, option.label] })
    : false;

  if (option.value === 'all' || setStatusFilterToAll) {
    return removeExistingFilter();
  }

  const { filterBehavior, updatedFilter, compareValue1ToChange } = createUpdatedFilter(field, option, existingFilter);

  const removeValueFromExistingFilter = () =>
    filters.map((f) =>
      f === existingFilter
        ? {
            ...updatedFilter,
            compareValue1: existingFilter.compareValue1.filter((v) => v !== compareValue1ToChange),
          }
        : f,
    );

  const newFilters = () => {
    switch (filterBehavior) {
      case 'remove':
        if (existingFilter.compareValue1.length > 1) return removeValueFromExistingFilter();
        return removeExistingFilter();
      case 'add':
        if (!existingFilter) return [...filters, updatedFilter];
        updatedFilter.compareValue1 = [...existingFilter.compareValue1, compareValue1ToChange];
        return filters.map((f) => (f === existingFilter ? updatedFilter : f));
      default:
    }
  };
  return newFilters();
};
